
export class IdNameCacheSimpleInfoBase {
	id!: number;
	name!: string;
	ine10?: string;
	code?: string;

	copy(entity: IdNameCacheSimpleInfo): void {
		Object.assign(this, entity)
	}

	static fromEntity(entity: IdNameCacheSimpleInfo): IdNameCacheSimpleInfoBase {
		let current = new IdNameCacheSimpleInfoBase();
		Object.assign(current, entity)

		return current;
	}
}

export interface IdNameCacheSimpleInfo extends IdNameCacheSimpleInfoBase {

}



